import { render } from "./MenuMinimized.vue?vue&type=template&id=455e76be&scoped=true"
import script from "./MenuMinimized.vue?vue&type=script&lang=js"
export * from "./MenuMinimized.vue?vue&type=script&lang=js"

import "./MenuMinimized.vue?vue&type=style&index=0&id=455e76be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455e76be"]])

export default __exports__